import { EMPTY_DISPLAY_VALUE } from '@assets/constants';
import {
  COUNTRY_DISTANCE_METRICS,
  DEFAULT_DISTANCE_METRIC,
} from '@assets/constants/country-distance-metrics.ts';

/**
 * Formats a distance received from the backend in metres using the country's
 * preferred unit. Unknown and missing ISO codes intentionally fall back to metres.
 */
export const formatDistanceByCountry = (
  isoCode: string | null | undefined,
  valueInMeters: number | null | undefined,
  fractionDigits = 1
): string => {
  if (valueInMeters == null || !Number.isFinite(valueInMeters)) return EMPTY_DISPLAY_VALUE;

  const metric = COUNTRY_DISTANCE_METRICS[isoCode?.toUpperCase() ?? ''] ?? DEFAULT_DISTANCE_METRIC;
  const value = valueInMeters * metric.multiplier;

  return `${value.toFixed(fractionDigits)} ${metric.suffix}`;
};
